import {labSvg as Icon__small__labSvg} from '../Icon__small/Icon__small--lab.js';

export var lab = {
  name: 'lab',
  category: 'icon',
  colorable: true,
  svg: Icon__small__labSvg,
};
